/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const nightScheduleSchema = z.object({
	am_night_open_time: z.iso.time().nullable(),
	am_night_close_time: z.iso.time().nullable(),
	pm_night_open_time: z.iso.time().nullable(),
	pm_night_close_time: z.iso.time().nullable(),
});
